import _ from 'lodash';
import { logger } from '../../Services';

import ApiError from '../ApiError';

import { _buildErrorObject, _getDataErrors } from './error-utils';

/**
 * ================================================================================================================
 * WARNING ! [Victor] WYN-6486
 * Methods in this file are not to be imported and used in other places. If you wish to import them please refer to the index file and make sure to compose them with the `_extractAxiosResponse` method so that you can ensure the response you pass down to them is safe. The methods in this folder that make use of them are already using the extract safe response.
 * ================================================================================================================
 */

//Catching 404 is a little tricky with axios so we need a specific method to grab if that does indeed happens.
export const _validateNetworkError = (response) => {
  if (
    !response.hasError && //check if the previous validator threw an error during the flow
    response.hasOwnProperty('message') &&
    response.message === 'Network Error'
  ) {
    logger.error(response.message);

    const error = _buildErrorObject({
      data: {
        status:    'error',
        statusmsg: response.message,
      },
      status: 404,
    });

    throw new ApiError(error);

    return {
      ...response,
      hasError: true,
    };
  } else return response;
};

//Our requests tend to have a 30 second default time(some can be configured to have different timeout timers), once that time is up we then fire the error message.
export const _validateTimeout = (response) => {
  if (
    !response.hasError && //check if the previous validator threw an error during the flow
    response.hasOwnProperty('code') &&
    response.code === 'ECONNABORTED'
  ) {
    logger.error(response);

    const error = _buildErrorObject({
      data: {
        status:    'error',
        statusmsg: 'Timeout exceeded',
      },
      status: 408,
    });

    throw new ApiError(error);
    return {
      ...response,
      hasError: true,
    };
  } else return response;
};

const _extractStatusFromData = (data) => {
  const status = _.get(data, 'status', '');
  if (typeof status === 'string' || status instanceof String) status.toLowerCase();
  else return status;
};
export const _validateNotOK = (response) => {
  const { status, data, hasError, config } = response;

  if (
    !hasError && //check if the previous validator threw an error during the flow
    (status !== 200 || (status === 200 && data.status !== 'ok' && config.responseType !== 'blob')) // blob response does not contain a status field, so we have to avoid error in this case
  ) {
    logger.error(response);
    const error = _buildErrorObject(response);

    if (data) {
      const errorsList = _.get(data, 'content.errors', data.failed);
      const dataErrors = _getDataErrors(
        response,
        !_.includes(['ok', 'success'], _extractStatusFromData) && !!errorsList
      );

      throw new ApiError(error, dataErrors);
    } else {
      throw new ApiError(error);
    }

    return {
      ...response,
      hasError: true,
    };
  } else return response;
};

// TEMPORARY
export const _validateWarnHelios = (response) => {
  if (
    !response.hasError && //check if the previous validator threw an error during the flow
    !_.includes(['ok', 'success'], response.data.status.toLowerCase())
  ) {
    response.data.status = 'warning';
    logger.warn(response);
    const error = _buildErrorObject(response);

    const errorsList = _.get(response.data, 'content.errors', response.data.failed);
    const dataErrors = _getDataErrors(response, !!errorsList);

    throw new ApiError(error, dataErrors);
    return {
      ...response,
      hasError: true,
    };
  } else return response;
};

export const _validateWarn = (response) => {
  if (
    !response.hasError && //check if the previous validator threw an error during the flow
    !_.includes(['ok', 'success'], response.data.status.toLowerCase())
  ) {
    response.data.status = 'warning';
    logger.warn(response);
    const error = _buildErrorObject(response);

    const errorsList = _.get(response.data, 'content.errors', response.data.failed);
    const dataErrors = _getDataErrors(response, !!errorsList);

    throw new ApiError(error, dataErrors);
    return {
      ...response,
      hasError: true,
    };
  } else return response;
};

const _isJSONRequest = (response) => {
  response.request.responseType === 'json';
};
export const _validateWarnCronos = (response) => {
  if (
    !response.hasError && //check if the previous validator threw an error during the flow
    _isJSONRequest(response) &&
    !_.includes(['ok', 'success'], response.data.status.toLowerCase())
  ) {
    logger.warn(response);
    const error = _buildErrorObject({ ...response, responseType: 'warning' });

    const errorsList = _.get(response.data, 'content.errors', response.data.failed);
    const dataErrors = _getDataErrors(response, !!errorsList);

    throw new ApiError(error, dataErrors);
    return {
      ...response,
      hasError: true,
    };
  } else return response;
};
